export default function logBuyNowRedirectToCheckoutReason(reason) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'buyNow',
        buyNowAction: 'CheckoutRedirect',
        buyNowRedirectReason: reason,
    });

    const csrfToken = document.head.querySelector('meta[name="csrf-token"]')?.content;
    if (!csrfToken) {
        return Promise.resolve();
    }

    return fetch('/store/checkout/one-click/redirect-reason/', {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': csrfToken,
        },
        body: JSON.stringify({
            reason,
        })
    });
}